import { TActiveAddOn } from "@/types/plan-data";
import { TAddOn } from "../types.checkout";

export type TAddOnItem = TAddOn & {
  quantity: number;
  interval: "month" | "year";
};

/**
 * Merges the user's purchased add-ons with their corresponding catalog cards,
 * enriching each entry with `quantity` and `interval` from the subscription.
 * Add-ons with no matching catalog card are excluded from the result.
 *
 * @param currentAddOnList - Add-ons the user has currently purchased
 * @param addOnCards - All available add-on cards from the checkout catalog
 */
export function getAddOnItemList(
  currentAddOnList: TActiveAddOn[],
  addOnCards: TAddOn[],
): TAddOnItem[] {
  return currentAddOnList
    .map((userAddOn) => {
      const addOnCard = addOnCards.find(
        (card) => card.productRefId === userAddOn.product_ref_id,
      );

      if (!addOnCard) return null;

      return {
        ...addOnCard,
        quantity: userAddOn.quantity,
        interval: userAddOn.recurring.interval,
      };
    })
    .filter((item): item is TAddOnItem => item !== null);
}
